import classNames from "classnames"
import { useUpdateHarvestEntryIsRunning } from "~/hooks/harvest"
import { HarvestTimeEntry } from "~/types"
import { HarvestButton } from "../HarvestButton/HarvestButton"
import HarvestClock from "../HarvestClock/HarvestClock"
import { IconPlay } from "../Icons/IconPlay"
import "./HarvestEntry.scss"

type Props = {
  entry: HarvestTimeEntry
  onUpdated: () => void
}

export function HarvestEntry({ entry, onUpdated }: Props) {
  const { mutate: updateEntryIsRunning, isPending } =
    useUpdateHarvestEntryIsRunning()

  return (
    <div
      className={classNames("HarvestEntry", {
        "HarvestEntry--running": entry.is_running,
      })}
    >
      <div className="HarvestEntry__left">
        {entry.notes ? (
          <p className="HarvestEntry__notes" title={entry.notes}>
            {entry.reference_link ? (
              <a
                href={entry.reference_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {entry.notes}
              </a>
            ) : (
              entry.notes
            )}
          </p>
        ) : (
          "No notes"
        )}
      </div>
      <div className="HarvestEntry__actions">
        {entry.is_running ? (
          <HarvestClock className="HarvestEntry__clock" />
        ) : (
          <HarvestButton
            className="HarvestEntry__button"
            isLoading={isPending}
            onClick={() =>
              updateEntryIsRunning(
                { entryId: entry.id, isRunning: !entry.is_running },
                { onSuccess: onUpdated },
              )
            }
          >
            <IconPlay />
          </HarvestButton>
        )}
      </div>
    </div>
  )
}
